<template>
    <tr class="h-12 w-full whitespace-nowrap bg-gray-100 flex items-center border-t border-gray-300 font-medium  text-gray-800 tracking-wide">
        <td :colspan="columnSpan" class="bg-gray-100 w-full">
            <div class="flex w-full justify-between items-center pr-2">
                <div class="pl-3 whitespace-nowrap w-full flex space-x-2">
                    <div v-if="viewingFromNbr==viewingToNbr" class="whitespace-nowrap">
                        Results: {{ viewingFromNbr }} of {{ count }}
                    </div>
                    <div v-else class="whitespace-nowrap">
                        Results: {{ viewingFromNbr }}-{{ viewingToNbr }} of {{ count }}
                    </div>
                    <div  class="whitespace-nowrap" v-if="selectedResults.length > 0">
                        ( {{ selectedResults.length }} Selected )
                    </div>
                </div>
                <div class="flex flex-row items-end justify-center px-2 w-full">
                    <div v-if="isLoading" role="status" class="">
                        <svg
                        aria-hidden="true"
                        class="w-5 h-5 animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="white"
                        />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#2E9CCA"
                        />
                        </svg>
                    </div>
                    <PaginationArrows
                        v-else
                        @get-next="getNext"
                        @go-to-first="goToFirst"
                        @get-prev="getPrev"
                        @go-to-last="goToLast"
                        @jump-to-page="jumpToPage"
                        :page="page"
                        :numPages="numPages"
                        :has-next="hasNext"
                        :has-prev="hasPrev"
                    ></PaginationArrows>
                </div>
                <div class="w-full flex justify-end items-center">

                </div>

                <!-- <div class="w-fit h-full flex py-2.5 pl-3 pr-1.5">
                    <FilterCompactHorizontal class="mx-2">
                        <template v-slot:label> Pg Size </template>
                        <template v-slot:widget>
                        <ListBoxHorizontal
                            class="w-12 rounded-r-md text-xs text-black"
                            placeholder="Select"
                            :options="pageSizeOptions"
                            :modelValue="pageSizeFilter"
                            :multiple="false"
                            @update:modelValue="setPageSizeFilter"
                        />
                        </template>
                    </FilterCompactHorizontal>
                </div> -->
            </div>
        </td>
    </tr>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed } from 'vue';
import PaginationArrows from '../base-components/PaginationArrows.vue';

const props = defineProps([
    'viewType', 
    'isLoading', 
    'viewingFromNbr', 
    'viewingToNbr', 
    'count',
    'numPages',
    'selectedResults',
    'page',
    'hasNext',
    'hasPrev'
])

const emit = defineEmits([
    'get-next',
    'go-to-first',
    'get-prev',
    'go-to-last',
    'jump-to-page',
    'set-page-size-filter'
])

const columnSpan = computed(() => {
    switch(props.viewType) {
        case 'imports':
            return 9
        case 'companies':
            return 7
        default:
            return 0
    }
})

function getNext() {
    emit("get-next");
  }
  
  function goToFirst() {
    emit("go-to-first");
  }
  
  function getPrev() {
    emit("get-prev");
  }
  
  function goToLast() {
    emit("go-to-last");
  }
  
  function jumpToPage(targetPage) {
    emit("jump-to-page", targetPage);
  }
  
</script>